const FormConfirmation = () => {
  document.addEventListener('DOMContentLoaded', () => {
    const downloadLink = document.querySelector('.download-link--external');

    if (downloadLink) {
      downloadLink.addEventListener('click', () => {
        const parentDiv = document.querySelector('div[formnumber="4"]');

        if (parentDiv) {
          const targetDiv = parentDiv.querySelector('.gform_wrapper');
          const confirmationDiv = parentDiv.querySelector(
            '.form-content-confirmation'
          );

          if (targetDiv) targetDiv.style.display = 'none';
          if (confirmationDiv) confirmationDiv.style.display = 'block';
        }
      });
    }
  });
};

export default FormConfirmation;
